// Port of ric-shim (Apache-2.0, Copyright 2015 Google Inc.) with native detection per call.
export function requestIdleCallback(cb: IdleRequestCallback, opts?: IdleRequestOptions): number {
  if (typeof globalThis.requestIdleCallback === 'function') {
    return globalThis.requestIdleCallback(cb, opts)
  }
  return setTimeout(() => {
    const start = Date.now()
    cb({
      didTimeout: false,
      timeRemaining: () => Math.max(0, 50 - (Date.now() - start)),
    })
  }, 1) as unknown as number
}

export function cancelIdleCallback(id: number): void {
  if (typeof globalThis.cancelIdleCallback === 'function') {
    globalThis.cancelIdleCallback(id)
    return
  }
  clearTimeout(id)
}
